import { ReactElement } from "react";
import MainLayout from "../../components/Layouts";
import PromoWiseSalesReport from "../../components/Reports/PromoWiseSalesReport";
import React from "react";
const PromoWiseSalesReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <PromoWiseSalesReport />
    </MainLayout>
  );
};

export default PromoWiseSalesReportPage;
